export default __webpack_public_path__ + "ffda0a4a63e135f7c9b7dd86629d9240.png";